import { forwardRef } from "react";
import classNames from "classnames";

const StarIcon = ({ filled }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 15.09 10.26 24 10.35 17.18 16.54 19.34 24.63 12 19.77 4.66 24.63 6.82 16.54 0 10.35 8.91 10.26 12 2" />
  </svg>
);

export const CRating = forwardRef(
  ({ value = 1, onChange, disabled = false }, ref) => {
    //#region Event
    const onStarClick = (newValue) => () => {
      onChange?.(newValue);
    };
    //#endregion

    //#region Render
    return (
      <div className="grid grid-cols-5 w-[135px] m-auto">
        {Array(10)
          .fill("")
          .map((e, index) => (
            <button
              key={`star-${index + 1}`}
              type="button"
              onClick={!disabled ? onStarClick(index + 1) : undefined}
              className={classNames(
                disabled
                  ? "cursor-default text-[#56b3a8a4]"
                  : "cursor-pointer text-[#5CB0A6]",
                "p-0 outline-none bg-transparent border-0 transition-all duration-100 hover:scale-110",
              )}
              disabled={disabled}
            >
              <StarIcon filled={value >= index + 1} />
            </button>
          ))}
      </div>
    );
    //#endregion
  },
);
